import { render, staticRenderFns } from "./AddIngredientForm.vue?vue&type=template&id=6f792666&"
import script from "./AddIngredientForm.vue?vue&type=script&lang=js&"
export * from "./AddIngredientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports